// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");

let Types = {};

let fragmentConverter = {"__root":{"members_edges_node":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "MarketingProfileMembersList_members", undefined);
}

function getConnectionNodes(connection) {
  return Stdlib_Array.filterMap(connection.edges, edge => {
    if (edge !== undefined) {
      return edge.node;
    }
  });
}

let Utils = {
  getConnectionNodes: getConnectionNodes
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "members"
        ]
      }
    ]
  },
  "name": "MarketingProfileMembersList_teamMarketingProfile",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "members",
        "args": null,
        "concreteType": "TeamMarketingProfileMemberConnection",
        "kind": "LinkedField",
        "name": "__MarketingProfileMembersList_members_connection",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": "TeamMarketingProfileMemberEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MarketingProfileMember",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MarketingProfileMembersList_member_marketingProfileMember"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            "action": "THROW"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "TeamMarketingProfile",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
